import { gql } from "@apollo/client";

const markOrderAsStockStagedByInventoryOrderCartonIdentifierMutation = gql`
  mutation($cartonIdentifier: String!) {
    markOrderAsStockStagedByInventoryOrderCartonIdentifier(cartonIdentifier: $cartonIdentifier) {
      errors {
        cartonIdentifier
      }
      order {
        id
        isStockStaged
      }
      succeeded
    }
  }
`;

export default markOrderAsStockStagedByInventoryOrderCartonIdentifierMutation;
